import { render, staticRenderFns } from "./CreateCampaignFaqPanel.vue?vue&type=template&id=10e1a9ec&scoped=true"
import script from "./CreateCampaignFaqPanel.vue?vue&type=script&lang=js"
export * from "./CreateCampaignFaqPanel.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignFaqPanel.vue?vue&type=style&index=0&id=10e1a9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e1a9ec",
  null
  
)

export default component.exports